<template>
<div class="chapter">
<div class="inner_page">
<h1 class="chapter"><strong>AUTHOR NOTE</strong></h1>
<p class="extract">I hope you will enjoy this medieval story about a young woman who is sent as a hostage in her cousin’s place to pay her uncle’s debt. At the very least she expects to be disparaged and returned to her family in disgrace, but what else can she do but obey her cousin? Her father has given all his money away and no longer cares about life. How can Rosamunde find a new life for them when she will lose both her honour and her chance of ever finding a husband?</p>
<p class="extract">Raphael has returned from the crusades a rich man, but he carries the memory of the woman he married there and her terrible death. When he discovers what his father has been doing while he was away he is ashamed, and determined to set an example to his men—but the latest hostage is beautiful, and her eyes seem to call to him. If he sets her free she might just be taken hostage again to satisfy Prince John’s greed.</p>
<p class="extract">Somehow he must find a way to make sure his lovely prisoner is cared for—for the rest of her life—but she thinks he is his father, a man lost to honour and reputation. How can he forget the shadows that haunt him and convince her that her happiness lies with him?</p>
<p class="extract">I know many of you love tales of knights and their ladies. I loved writing this one and hope you will find pleasure in reading it.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// aun.vue?3e7a8eae